export function isNullOrUndefined(data: any) {
    return (
        (Array.isArray(data) && data.length === 0) ||
        data === undefined ||
        data === null ||
        data === ''
    );
}

export function isNullOrUndefinedOrEmpty(data: any) {
    return isNullOrUndefined(data) || data === '' ? true : false;
}

export function isNotNullOrUndefined(data: any) {
    return !isNullOrUndefined(data);
}

export function isNotNullOrUndefinedOrEmpty(data: any) {
    return !isNullOrUndefinedOrEmpty(data);
}
